import { render, staticRenderFns } from "./LuckyRolls.vue?vue&type=template&id=098d147c&"
import script from "./LuckyRolls.vue?vue&type=script&lang=js&"
export * from "./LuckyRolls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports